export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&',
  },
  {
    name: 'social_icon',
    label: 'Social Icon',
    selector: '& .social-icon',
  },
  {
    name: 'social_icon_icon',
    label: 'Icon',
    selector: '& svg',
  },
];
